"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OceanCity = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Resources_1 = require("../../Resources");
const TileType_1 = require("../../TileType");
const CardType_1 = require("./../CardType");
const Tags_1 = require("./../Tags");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class OceanCity extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.OCEAN_CITY,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.BUILDING],
            cost: 18,
            productionBox: Units_1.Units.of({ energy: -1, megacredits: 3 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oceans(6)),
            metadata: {
                cardNumber: 'A20',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.minus().energy(1).br;
                        pb.plus().megacredits(3);
                    }).nbsp().tile(TileType_1.TileType.OCEAN_CITY, false, true);
                }),
                description: 'Requires 6 ocean tiles. Decrease your Energy production 1 step and increase your M€ production 3 steps. Place this tile on top of an existing ocean tile, IGNORING NORMAL PLACEMENT RESTRICTIONS FOR CITIES. The tile counts as a city as well as an ocean.',
            },
        });
    }
    canPlay(player) {
        return super.canPlay(player) && (player.getProduction(Resources_1.Resources.ENERGY) > 0);
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.addProduction(Resources_1.Resources.MEGACREDITS, 3);
        return new SelectSpace_1.SelectSpace('Select space for Ocean City', player.game.board.getOceansTiles(false), TileType_1.TileType.OCEAN_CITY, (space) => {
            const tile = {
                tileType: TileType_1.TileType.OCEAN_CITY,
                card: this.name,
                covers: space.tile,
            };
            player.game.addTile(player, space.spaceType, space, tile);
            return undefined;
        });
    }
}
exports.OceanCity = OceanCity;
//# sourceMappingURL=OceanCity.js.map